import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';

class FormSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      isFocused: false
    }

    this.handleChange = this.handleChange.bind(this);
    this.toggle = this.toggle.bind(this);
    this.focusEvent = this.focusEvent.bind(this);
    this.blurEvent = this.blurEvent.bind(this);
    this.focus = this.focus.bind(this);
    this.renderChildren = this.renderChildren.bind(this);

  }
  handleChange(event) {     
    this.inputRef.focus();
    this.props.handleChange(event);
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  focusEvent() {
    this.setState({
      isFocused: true
    });
  }
  blurEvent(event) { 
    this.setState({
      isFocused: false
    });  
    this.props.validateField({target: {name: this.props.name, value: this.props.value}});
  }
  focus() {
    this.inputRef.focus();
  }
  renderChildren() {
    return React.Children.map(this.props.children, child => {
      return React.cloneElement(child, {
        onClick: this.handleChange,
        name: this.props.name,
        autoFocus: (child.props.value === this.props.value)
      });
    });
  }
  render() {
    return (
      <Dropdown isOpen={this.state.isOpen} toggle={this.toggle} className={`form-select ${(this.props.isInvalid ? "is-invalid" : "")} ${(this.state.isFocused ? "active" : "")}`} onFocus={this.focusEvent} onBlur={this.blurEvent}>
        <DropdownToggle name={this.props.name} caret innerRef={(ref) => this.inputRef = ref} autoFocus={this.props.autoFocus} disabled={this.props.disabled}>
          {this.props.label}
        </DropdownToggle>
        <DropdownMenu>
          {this.renderChildren()}
        </DropdownMenu>
      </Dropdown>
    );
  }
}
FormSelect.defaultProps= {
  name: "",
  value: "",
  label: "",
  isInvalid: false,
  validateField: () => {},
  autoFocus: false,
  disabled: false
};

FormSelect.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  isInvalid: PropTypes.bool,
  validateField: PropTypes.func,
  handleChange: PropTypes.func,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool
};

export default FormSelect;


// WEBPACK FOOTER //
// ./src/components/FormSelect/FormSelect.js